<div class="form-group ui-i18n-phone-input">
  <label *ngIf="showLabel" class="fw-bold font-{{ labelFontSize }}">
    {{ label || ('common.mobile' | translate) }}
  </label>

  <div class="input-group clearfix">

    <div id="phone-prefix-toggle"
         [class.input-group-addon_active]="isOpenCountryContainer"
         [class.input-group-addon_disabled]="disabled"
         class="input-group-addon pointer"
         (click)="isOpenCountryContainer ? onCloseCountryContainer() : onOpenCountryContainer($event)"
    >
      <span class="ui-prefix d-flex align-items-center">
        <span class="flag {{ selectedCountry.flagClass }}"></span>
        <strong class="ms-2">
          +{{ selectedCountry.dialCode }}
        </strong>
      </span>
    </div>
    <input
      #phoneNumberInput
      type="tel"
      class="form-control"
      name="phone"
      autocomplete="tel"
      [class.form-control_active]="isOpenCountryContainer"
      [ngModel]="value"
      [inputMaskArgs]="{countryCode: selectedCountry.iso2.toLowerCase()}"
      [required]="required"
      [inputMask]="'phoneIncludingPlus'"
      [maxlength]="32"
      [placeholder]="placeholder"
      (input)="onPhoneNumberChange($event)"
      (blur)="onTouched()">
  </div>

  <ng-content *ngIf="!isOpenCountryContainer"></ng-content>

  <ui-search-bar
    *ngIf="isOpenCountryContainer"
    click-outside
    class="ui-i18n-phone-input-country-container"
    (clickOutside)="onClickOutside($event, 'phone-prefix-toggle')"
    [itemTemplate]="itemTemplate"
    [styleType]="'border-radius-none ui-i18n-phone-input'"
    [takeLimit]="takeLimit"
    [placeholder]="'common.inputPhoneNumber.searchCountryPlaceholder' | translate"
    [selectedItem]="null"
    [nothingFoundTemplate]="nothingFoundCountry && nothingFound"
    [itemsSourceFn]="searchCountry.bind(this)"
    [autoFocus]="true"
    (onSelected)="onSelectCountry($event)">
  </ui-search-bar>
</div>

<ng-template #itemTemplate let-country="item">
  <li *ngIf="!country.nothingFound" class="country d-flex align-items-center">
    <span class="{{ country.flagClass }}"></span>
    <span class="ms-3 country-name">{{country.translate | translate}}</span>
    <span class="dial-code ps-1">+{{country.dialCode}}</span>
  </li>
</ng-template>

<ng-template #nothingFound>
  <div class="nothing-found" (click)="sendNothingFoundExceptionToSentry()">
    <div class="d-flex align-items-center" *ngIf="!isSendingNothingFoundRequest">
      {{ 'common.inputPhoneNumber.nothingFound.warningMessage' | translate }},
      <span
        class="btn py-0 px-1 font-lg btn-text-primary">{{ 'common.inputPhoneNumber.nothingFound.actionMessage' | translate }}</span>
    </div>
    <ui-message type="success"
                *ngIf="isSendingNothingFoundRequest">
      {{ 'common.inputPhoneNumber.nothingFound.successMessage' | translate }}
    </ui-message>
  </div>
</ng-template>
